module.exports = __webpack_public_path__ + "static/media/logo.95609d0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/nav/logo.svg
// module id = 324
// module chunks = 0